import { ActionButton, BaseTable, Button, Loading } from "components"
import { convertNumber, useApi } from "utils"
import { convertDate } from "pages/Inventori/Transaction/TransactionJournal/utils"
import { ModalConfigType, RefundItemListResponse } from "../types"
import { convertApproval, convertReceivedReject } from "../utilities"
import { IoSendSharp } from "react-icons/io5"
import { ModalDetailRefundItem } from "./modal-detail-refund-item"
import { useState } from "react"
import { ApprovalEnum } from "../enum"
import toast from "react-hot-toast"
import { PERMISION } from "security"

type TableListRefundItemProps = {
  data: RefundItemListResponse[]
  isLoading?: boolean
  refetch?: () => void
}

export const TableListRefundItem = ({ data, isLoading, refetch }: TableListRefundItemProps) => {
  const api = useApi()

  const [modalConfig, setModalConfig] = useState<ModalConfigType>({ show: false, id: null })

  const getRejectedDifference = (qty_received: number, qty_rejected: number): number => {
    return (qty_rejected || 0) - (qty_received || 0);
  }

  return (
    <div className="overflow-x-auto max-h-[calc(100vh-640px)]">
      <BaseTable className="border-transparent">
        <thead className="top-0 z-1 !bg-black !text-white">
          <tr className="uppercase">
            <th>No</th>
            <th>RETURN REFUND ID#</th>
            <th>REF RETURN ITEM ID#</th>
            <th>REF INVOICE ID#</th>
            <th>DATE</th>
            <th>TYPE</th>
            <th>LOCATION</th>
            <th>CUSTOMER</th>
            <th>STATUS APPROVAL</th>
            <th>QTY RETURN</th>
            <th>QTY REFUND</th>
            <th>BACK RETURN</th>
            <th>SUBTOTAL</th>
            <th>ACTION</th>
          </tr>
        </thead>
        <tbody>
        {isLoading ? (
          <tr>
            <td colSpan={15} className="text-center">
              <Loading loading />
            </td>
          </tr>
        ) : data.length === 0 ? (
          <tr>
            <td colSpan={15} className="text-center">
              <Loading loading={false} errorText="No data available" />
            </td>
          </tr>
        ) : (
            data.map((val, index) => (
              <tr>
                <td>{index + 1}</td>
                <td>{val?.trx_code ?? "-"}</td>
                <td>{val?.return_trx_code ?? "-"}</td>
                <td>{val?.invoice_trx_code ?? "-"}</td>
                <td>{val?.transaction_date ? convertDate(val?.transaction_date) : "-"}</td>
                <td>{val?.type_refund ? convertReceivedReject(val?.type_refund) : "-"}</td>
                <td>{val?.location_name ?? "-"}</td>
                <td>{val?.customer_name ?? "-"}</td>
                <td>{val?.approve_status ? convertApproval(val?.approve_status) : "-"}</td>
                <td className="text-center">{val?.qty_return ? convertNumber(Number(val?.qty_return))?.intoNormalAmount : "-"}</td>
                <td className="text-center">{val?.qty ? convertNumber(Number(val?.qty))?.intoNormalAmount : "-"}</td>
                <td className="text-center">{getRejectedDifference(Number(val?.qty), Number(val?.qty_return))}</td>
                <td className="text-right">{val?.subtotal ? convertNumber(Number(val?.subtotal))?.intoCurrency : "-"}</td>
                <td>
                  <section className="flex items-center gap-2">
                    <Button type="button" color="ghost" permission={PERMISION.SALES.REGISTER.RERUND_ITEM.UPDATE} onClick={() => setModalConfig({ show: true, id: val?.refund_return_id })}>
                      <IoSendSharp />
                    </Button>
                    {val?.approve_status === ApprovalEnum.PENDING && <ActionButton.Delete permission={PERMISION.SALES.REGISTER.RERUND_ITEM.DELETE} onClick={() => {
                      if (!val?.refund_return_id) return;

                      toast.promise(
                        api.delete(`/received/delete_refund?refund_return_id=${val.refund_return_id}`)
                        .then(() => refetch && refetch()),
                        {
                          loading: 'Deleting...',
                          success: 'Refund Item deleted successfully!',
                          error: 'Failed to delete Refund Item.',
                        }
                      );
                    }} />}
                  </section>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </BaseTable>

      {(modalConfig.id && modalConfig.show) && <ModalDetailRefundItem id={modalConfig.id} toggle={setModalConfig} />}
    </div>
  )
}
